// Cards.jsx
import React from "react";
import "./Cards.css";
import ieltsImg from "../asset/IELTS-EXAM-FEES-IN-INDIA.jpg.webp";
import gmatImg from "../asset/Gmat.png";
import toeflImg from "../asset/toefl.jpg";

const Cards = () => {
  const coachingCards = [
    {
      id: 1,
      title: "IELTS",
      image: ieltsImg,
      description:
        "Provides expert training to help students achieve high scores in the IELTS exam, essential for studying abroad."
    },
    {
      id: 2,
      title: "GMAT",
      image: gmatImg,
      description:
        "Offers specialized training to boost students' scores, crucial for admission to top business Institute worldwide."
    },
    {
      id: 3,
      title: "TOEFL",
      image: toeflImg,
      description:
        "Delivers targeted training to enhance students' scores, vital for gaining admission to international universities."
    }
  ];

  return (
    <div>
      <div className="cards-section">
        <div className="cards-title-wrapper">
          <h1 className="cards-title Darkerr">Free Expert Coaching For</h1>
        </div>
      </div>

      <div className="cards-container">
        {coachingCards.map((card) => (
          <div
            className={`cards-item ${card.title === "IELTS" ? "img-contain" : ""}`}
            key={card.id}
          >
            <img src={card.image} alt={card.title} />
            <div className="cards-content">
              <h4 className="cards-item-title">{card.title}</h4>
              <p className="cards-item-description">{card.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Cards;
